import CloseIcon from "@mui/icons-material/Close";
import { Drawer, IconButton, useTheme } from "@mui/material";
import React, { forwardRef, useImperativeHandle, useState } from "react";

const drawerComponentStyle = {
  "& .MuiDrawer-paper": {
    width: { xs: "100%", md: "50%" },
  },
  "& .MuiDrawer-paper .drawer-close-icon": {
    position: "fixed",
    top: 16,
    left: "46%",
    zIndex: 1300,
    backgroundColor: "custom.white",
    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
  },
};

const SelectTime = forwardRef(({ selectedEvent }, ref) => {
  const { palette } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  // Use useImperativeHandle to expose open/close methods to parent components
  useImperativeHandle(ref, () => ({
    openDrawer: () => setIsOpen(true),
    closeDrawer: () => setIsOpen(false),
  }));

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={() => setIsOpen(false)}
      sx={{ ...drawerComponentStyle }}
    >
      <IconButton
        className="drawer-close-icon"
        onClick={() => setIsOpen(false)}
      >
        <CloseIcon />
      </IconButton>
    </Drawer>
  );
});

export default SelectTime;
